import * as actionTypes from "./customerActionType";
import axios from 'axios';
import { checkError, apiTimeout } from './../error';
import { toast } from 'react-toastify';
import { extractPaymentCustomer, persistCustomerSession, customerAuthHeaders } from '../../utils/customerSession';

const { REACT_APP_API_URL } = process.env;


export const customerFetch = (params) => {
  const config = { headers: { Authorization: `Bearer ${localStorage.getItem("customerToken")}` } };
  return (dispatch) => {
    dispatch(customerFetchInit());
    apiTimeout(axios.get(`${REACT_APP_API_URL}/customer`, { ...config, params }))
      .then((response) => {
        dispatch(customerFetchSuccess(response.data.data));
      })
      .catch(function (error) {
        dispatch(customerFetchFailure());
        checkError(error);
      })
  };
};

export const customerFetchInit = () => ({
  type: actionTypes.CUSTOMER_FETCH
});

export const customerFetchFailure = () => ({
  type: actionTypes.CUSTOMER_FETCH_FAILURE
});

export const customerFetchSuccess = data => ({
  type: actionTypes.CUSTOMER_FETCH_SUCCESS,
  payload: { data }
});

export const customerUpdate = (data) => {
  const config = { headers: { Authorization: `Bearer ${localStorage.getItem("customerToken")}` } };
  return (dispatch) => {
    dispatch(customerUpdateInit());
    apiTimeout(axios.put(`${REACT_APP_API_URL}/customer/${data.currentUser ? "" : data.id}`, data, config))
      .then((response) => {
        dispatch(customerUpdateSuccess(response.data.data));
        toast.success("Update successfully", {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 3000
        });
      })
      .catch(function (error) {
        dispatch(customerUpdateFailure());
        checkError(error);
      })
  };
};

export const customerUpdateInit = () => ({
  type: actionTypes.CUSTOMER_UPDATE
});

export const customerUpdateFailure = () => ({
  type: actionTypes.CUSTOMER_UPDATE_FAILURE
});

export const customerUpdateSuccess = () => ({
  type: actionTypes.CUSTOMER_UPDATE_SUCCESS
});

export const customerLogin = (data) => {
  return (dispatch) => {
    dispatch(customerLoginInit());
    // If OTP is provided, use OTP login endpoint, otherwise use password login
    const endpoint = data.otp 
      ? `${REACT_APP_API_URL}/customer/authenticate-otp`
      : `${REACT_APP_API_URL}/customer/authenticate`;
    
    apiTimeout(axios.post(endpoint, data))
      .then((response) => {
        const session = persistCustomerSession(response.data.data);
        dispatch(customerLoginSuccess(session));
      })
      .catch(function (error) {
        dispatch(customerLoginFailure());
        checkError(error);
      })
  };
};

export const customerLoginInit = () => ({
  type: actionTypes.CUSTOMER_LOGIN
});

export const customerLoginFailure = () => ({
  type: actionTypes.CUSTOMER_LOGIN_FAILURE
});

export const customerLoginSuccess = data => ({
  type: actionTypes.CUSTOMER_LOGIN_SUCCESS,
  payload: { data }
});

export const customerRegister = (data) => {
  return (dispatch) => {
    dispatch(customerRegisterInit());
    apiTimeout(axios.post(`${REACT_APP_API_URL}/customer/register`, data))
      .then((response) => {
        const session = persistCustomerSession(response.data.data);
        dispatch(customerRegisterSuccess(session));
      })
      .catch(function (error) {
        dispatch(customerRegisterFailure());
        checkError(error);
      })
  };
};

export const customerRegisterInit = () => ({
  type: actionTypes.CUSTOMER_REGISTER
});

export const customerRegisterFailure = () => ({
  type: actionTypes.CUSTOMER_REGISTER_FAILURE
});

export const customerRegisterSuccess = data => ({
  type: actionTypes.CUSTOMER_REGISTER_SUCCESS,
  payload: { data }
});


export const currentCustomerFetch = () => {
  const config = { headers: { Authorization: `Bearer ${localStorage.getItem("customerToken")}` } };
  return (dispatch) => {
    dispatch(currentCustomerFetchInit());
    apiTimeout(axios.get(`${REACT_APP_API_URL}/customer/current`, config))
      .then((response) => {
        dispatch(currentCustomerFetchSuccess(response.data.data));
        persistCustomerSession({
          ...(JSON.parse(localStorage.getItem('loggedCustomer') || '{}')),
          ...response.data.data,
        });
      })
      .catch(function (error) {
        dispatch(currentCustomerFetchFailure());
        checkError(error);
      })
  };
};

export const currentCustomerFetchInit = () => ({
  type: actionTypes.CURRENT_CUSTOMER_FETCH
});

export const currentCustomerFetchFailure = () => ({
  type: actionTypes.CURRENT_CUSTOMER_FETCH_FAILURE
});

export const currentCustomerFetchSuccess = data => ({
  type: actionTypes.CURRENT_CUSTOMER_FETCH_SUCCESS,
  payload: { data }
});

export const customerForget = (data) => {
  return (dispatch) => {
    dispatch(customerForgetInit());
    apiTimeout(axios.post(`${REACT_APP_API_URL}/customer/forget-password`, data))
    .then((response) => {
          toast.success("Email sent to registered email address. Follow to recover password.", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored"
          });
        dispatch(customerForgetSuccess(response.data.data));
    })
    .catch(function (error) {
        dispatch(customerForgetFailure());
        checkError(error);
    })
};
};

export const customerForgetInit = () => ({
type: actionTypes.CUSTOMER_FORGET
});

export const customerForgetFailure = () => ({
type: actionTypes.CUSTOMER_FORGET_FAILURE
});

export const customerForgetSuccess = data => ({
type: actionTypes.CUSTOMER_FORGET_SUCCESS,
payload: { data }
});

export const customerForgetReset = (token, data) => {
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return (dispatch) => {
    dispatch(customerForgetResetInit());
    apiTimeout(axios.post(`${REACT_APP_API_URL}/customer/reset-password`, data, config))
    .then((response) => {
          toast.success("Your password has been reset. Please login again", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored"
          });
        dispatch(customerForgetResetSuccess(response.data.data));
    })
    .catch(function (error) {
        dispatch(customerForgetResetFailure());
        checkError(error);
    })
};
};

export const customerForgetResetInit = () => ({
type: actionTypes.CUSTOMER_FORGET_RESET
});

export const customerForgetResetFailure = () => ({
type: actionTypes.CUSTOMER_FORGET_RESET_FAILURE
});

export const customerForgetResetSuccess = data => ({
type: actionTypes.CUSTOMER_FORGET_RESET_SUCCESS,
payload: { data }
});


//Helper Function
function setLoginSession(data) {
  persistCustomerSession(data);
}

/** Log in customer from booking payment confirmation (or other server-issued session) */
/** Lookup returning guest profile for checkout autofill (no login token) */
// ── OTP login shared with the StayJade app (email or mobile → OTP → access + refresh token) ──
const unwrap = (response) => response.data?.data ?? response.data;
const apiErrorMessage = (err, fallback) => err?.response?.data?.message || fallback;

/** { exists, channel, maskedContact, needsSignup } — no personal data */
export const stayjadeLookup = (contact) =>
  apiTimeout(axios.post(`${REACT_APP_API_URL}/customer/stayjade/lookup`, { contact })).then(unwrap);

export const stayjadeSendOtp = (contact) =>
  apiTimeout(axios.post(`${REACT_APP_API_URL}/customer/stayjade/send-otp`, { contact }))
    .then(unwrap)
    .catch((err) => {
      throw new Error(apiErrorMessage(err, "We couldn't send the code. Please try again."));
    });

/**
 * { accessToken, refreshToken, user, isNewUser }. For a new account pass { firstName, lastName }
 * — the account is created on successful verification.
 */
export const stayjadeVerifyOtp = (contact, otp, signup = {}) =>
  apiTimeout(
    axios.post(`${REACT_APP_API_URL}/customer/stayjade/verify-otp`, { contact, otp, ...signup })
  )
    .then(unwrap)
    .catch((err) => {
      throw new Error(apiErrorMessage(err, "That code didn't work. Please try again."));
    });

/** Records Terms + Privacy acceptance for a newly created account (DPDP consent, as in the app). */
export const stayjadeAcceptConsent = (accessToken) =>
  apiTimeout(
    axios.post(
      `${REACT_APP_API_URL}/customer/stayjade/accept-consent`,
      { acceptTerms: true, acceptPrivacy: true },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
  ).then(unwrap);

/** Adds the contact a new account signed up without (email or phone) — returns the updated user. */
export const stayjadeFillMissingContact = (accessToken, contact) =>
  apiTimeout(
    axios.post(
      `${REACT_APP_API_URL}/customer/stayjade/fill-missing-contact`,
      { contact },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
  )
    .then(unwrap)
    .catch((err) => {
      throw new Error(apiErrorMessage(err, "We couldn't save your contact details."));
    });

/** Public programme figures: { welcomeBonusAmount, redemptionCapPercent, minBalanceToSpend } */
export const fetchJadeProgram = () =>
  apiTimeout(axios.get(`${REACT_APP_API_URL}/customer/jade-program`)).then(unwrap);

/** Signed-in guest's Jade Points ({ balance, expiresAt, ... }) */
export const fetchMyJadePoints = () =>
  apiTimeout(axios.get(`${REACT_APP_API_URL}/stayjade/points`, customerAuthHeaders())).then(unwrap);

/** Jade Points this stay would earn if booked in the StayJade app ({ earn: { amount, ratePercent } | null }) */
export const fetchJadePointsPreview = (params) =>
  apiTimeout(axios.post(`${REACT_APP_API_URL}/customer/jade-points-preview`, params)).then(
    (response) => response.data?.data ?? response.data
  );

export const restoreCustomerSession = (data) => (dispatch) => {
  const session =
    extractPaymentCustomer({ customer: data }) ?? (data?.token ? data : null);
  if (!session?.token && !session?.accessToken) return;
  const profile = persistCustomerSession(session);
  dispatch(customerLoginSuccess(profile));
};

export const updateCustomer = data => ({
  type: actionTypes.UPDATE_PROFILE_DATA,
});
